import { ArtistPageController } from './artist/controller';
import { APIController } from '../api/controller';
import { CheckoutPageController } from './checkout/controller';
import { HomePageController } from './home/controller';
import { AuthController } from '../auth/controller';
import { PricingPageController } from './pricing/controller';
import { ClientModel } from '../client/model';
import { BasketController } from '../basket/controller';
import { AccountPageController } from './account/controller';
import { AccountLicencesPageController } from './account-licences/controller';
import { AccountOrdersPageController } from './account-orders/controller';
import { AccountOrderPageController } from './account-order/controller';
import { SearchPageController } from './search/controller';
import { UIController } from '../ui/controller';
import { MasterPageController } from './master/controller';
import { FlashController } from '../flash/controller';
import { AccountChannelsPageController } from './account-channels/controller';
import { AccountChannelPageController } from './account-channel/controller';
import { AccountBillingPageController } from './account-billing/controller';
import { CheckoutController } from '../checkout/controller';
import { TermsAndConditionsPageController } from './terms-and-conditions/controller';
import { PrismicController } from '../prismic/controller';
import { ContactPageController } from './contact/controller';
import { PrivacyPolicyPageController } from './privacy-policy/controller';
import { FAQPageController } from './faq/controller';
import { AboutPageController } from './about/controller';
import { BugsnagController } from '../bugsnag/controller';
import { AccountCommunicationPageController } from './account-communication/controller';
import { ImageController } from '../image/controller';
import { SwapoutsPageController } from './swapouts/controller';
import { LicensingPageController } from './licensing/controller';
import { AccountInvitesPageController } from './account-invites/controller';
import { CookiePolicyPageController } from './cookie-policy/controller';
import { AnalyticsController } from '../analytics/controller';
import { ArtistsPageController } from './artists/controller';
import { AccountAttributionPageController } from './account-attribution/controller';
import { FavouritesPageController } from './favourites/controller';
import { FeaturesPageController } from './features/controller';
import { TrackPageController } from './track/controller';
import { AccountProfilePageController } from './account-profile/controller';
import { DiscoverPageController } from './discover/controller';
import { YouTubePageController } from './youtube/controller';
import {MusicSubmissionsPageController} from './music-submissions/controller';
import {LearnPageController} from './learn/controller';
import {BrowsePageController} from './browse/controller';
import {EditorPageController} from './editor/controller';
import {CareersPageController} from './careers/controller';
import {SigninPageController} from './signin/controller';
import {ArticlesPageController} from './articles/controller';
import {GoldenTicketPageController} from './golden-ticket/controller';
import {ChannelReferralPageController} from './channel-referral/controller';
import {AccountCouponsPageController} from './account-coupons/controller';
import {LandingPageController} from './landing/controller';
import {PlaylistController} from "../playlist/controller";

export class PageController {
  master: MasterPageController;
  signin: SigninPageController;
  home: HomePageController;
  articles: ArticlesPageController;
  artist: ArtistPageController;
  checkout: CheckoutPageController;
  browse: BrowsePageController;
  pricing: PricingPageController;
  account: AccountPageController;
  accountCoupons: AccountCouponsPageController;
  accountInvites: AccountInvitesPageController;
  accountLicences: AccountLicencesPageController;
  accountAttribution: AccountAttributionPageController;
  accountOrders: AccountOrdersPageController;
  accountOrder: AccountOrderPageController;
  accountChannels: AccountChannelsPageController;
  accountChannel: AccountChannelPageController;
  accountBilling: AccountBillingPageController;
  accountCommunication: AccountCommunicationPageController;
  accountProfile: AccountProfilePageController;
  contact: ContactPageController;
  search: SearchPageController;
  faq: FAQPageController;
  about: AboutPageController;
  privacyPolicy: PrivacyPolicyPageController;
  termsAndConditions: TermsAndConditionsPageController;
  cookiePolicy: CookiePolicyPageController;
  licensing: LicensingPageController;
  swapouts: SwapoutsPageController;
  artists: ArtistsPageController;
  favourites: FavouritesPageController;
  features: FeaturesPageController;
  track: TrackPageController;
  discover: DiscoverPageController;
  youtube: YouTubePageController;
  musicSubmissions: MusicSubmissionsPageController;
  learn: LearnPageController;
  careers: CareersPageController;
  editor: EditorPageController;
  goldenTicket: GoldenTicketPageController;
  channelReferral: ChannelReferralPageController;
  landing: LandingPageController;

  constructor(
    model: ClientModel,
    api: APIController,
    auth: AuthController,
    basket: BasketController,
    ui: UIController,
    flash: FlashController,
    checkout: CheckoutController,
    prismic: PrismicController,
    bugsnag: BugsnagController,
    image: ImageController,
    analytics: AnalyticsController,
    playlist: PlaylistController,
  ) {
    this.master = new MasterPageController(ui, model.env);
    this.signin = new SigninPageController(model.page.signin, model.env, model.router);
    this.home = new HomePageController(model.page.home, model.env, api.browse, prismic, image, model.content, bugsnag, model.mailchimp, api.pricing, analytics, ui);
    this.articles = new ArticlesPageController(model.page.articles);
    this.artist = new ArtistPageController(model.page.artist, model.env, ui, api.artist, api.release, image, model.router, bugsnag, model.content);
    this.checkout = new CheckoutPageController(model.page.checkout, checkout, model.checkout, ui, model.env);
    this.browse = new BrowsePageController(model.page.browse, api, ui, bugsnag, model.content, model.env, prismic, image, model.router);
    this.pricing = new PricingPageController(model.page.pricing, prismic, bugsnag, model.env, api, ui, model.content);
    this.account = new AccountPageController(model.page.account, model.env, prismic, bugsnag, ui, api, model.user);
    this.accountCoupons = new AccountCouponsPageController(model.page.accountCoupons, model.user, api, bugsnag, ui, model.env);
    this.accountInvites = new AccountInvitesPageController(model.page.accountInvites, model.user, api, flash, prismic, bugsnag, ui, model.env, model.content);
    this.accountLicences = new AccountLicencesPageController(model.user, model.page.accountLicences, api, model.env, ui);
    this.accountAttribution = new AccountAttributionPageController(model.page.accountAttribution, model.user, api, bugsnag, ui, model.env);
    this.accountOrders = new AccountOrdersPageController(model.user, model.page.accountOrders, api, model.env, ui);
    this.accountOrder = new AccountOrderPageController(model.user, model.page.accountOrder, api, model.env, ui);
    this.accountChannels = new AccountChannelsPageController(model.user, model.page.accountChannels, api, model.env, ui);
    this.accountChannel = new AccountChannelPageController(model.user, model.page.accountChannel, api, model.env, ui);
    this.accountBilling = new AccountBillingPageController(model.user, model.page.accountBilling, api, model.env, ui);
    this.accountCommunication = new AccountCommunicationPageController(model.page.accountCommunication, model.auth, api, flash, model.env, prismic, ui, auth);
    this.accountProfile = new AccountProfilePageController(model.user, model.page.accountProfile, api, ui, model.content, model.env, auth);
    this.contact = new ContactPageController(model.page.contact, prismic, bugsnag, model.env, ui);
    this.search = new SearchPageController(model.page.search, ui, model.env, model.router, api, analytics, model.content);
    this.faq = new FAQPageController(model.page.faq, prismic, bugsnag, model.env, ui);
    this.about = new AboutPageController(model.page.about, prismic, bugsnag, model.env, ui);
    this.privacyPolicy = new PrivacyPolicyPageController(model.page.privacyPolicy, prismic, bugsnag, model.env, ui);
    this.termsAndConditions = new TermsAndConditionsPageController(model.page.termsAndConditions, prismic, bugsnag, model.env, ui);
    this.cookiePolicy = new CookiePolicyPageController(model.page.cookiePolicy, prismic, bugsnag, model.env, ui);
    this.licensing = new LicensingPageController(model.page.licensing, prismic, bugsnag, model.env, ui);
    this.swapouts = new SwapoutsPageController(model.page.swapouts, prismic, bugsnag, model.env, ui);
    this.artists = new ArtistsPageController(model.page.artists, model.env, api, ui, image, bugsnag, prismic, model.router);
    this.favourites = new FavouritesPageController(model.page.favourites, prismic, bugsnag, model.env, api, model.user, model.playlist, model.artistlist, ui, model.cache);
    this.features = new FeaturesPageController(model.page.features, prismic, bugsnag, model.env, ui);
    this.track = new TrackPageController(model.page.track, bugsnag, model.env, api, ui, model.content, image);
    this.discover = new DiscoverPageController(model.page.discover, prismic, bugsnag, model.env, ui, model.router);
    this.youtube = new YouTubePageController(model.page.youtube, prismic, bugsnag, model.env, ui);
    this.musicSubmissions = new MusicSubmissionsPageController(model.page.musicSubmissions, prismic, bugsnag, model.env, ui);
    this.learn = new LearnPageController(model.page.learn, prismic, bugsnag, model.env, ui, model.router, model.content);
    this.careers = new CareersPageController(model.page.careers, prismic, bugsnag, model.env, ui, model.router);
    this.editor = new EditorPageController(model.page.editor);
    this.goldenTicket = new GoldenTicketPageController(model.page.goldenTicket, prismic, bugsnag, model.env, ui, image);
    this.channelReferral = new ChannelReferralPageController(model.page.channelReferral, prismic, bugsnag, model.env, ui, image);
    this.landing = new LandingPageController(model.page.landing,  prismic, bugsnag, model.env, ui, model.router, model.content)
  }
}